import { html } from 'lit';
import type { TefComsButton } from '@src/components/TefComsButton';

// a single button that disables itself if some filter is used
export const tefComsButton = function render(this: TefComsButton) : ReturnType<typeof html> {
  return html`
    <a class="button button-tag button-tag--size-small" ?disabled=${this.disabled} @click="${this.handleClick}">
      ${this.text}
    </a>`;
};
